import { Plane, SmilePlus, Sparkles } from "lucide-react";
import Reveal from "./Reveal";
import SectionHeader from "./SectionHeader";
import { useLanguage } from "../context/LanguageContext";
import { BUSINESS } from "../data/siteConfig";

const ICONS = { dental: SmilePlus, aesthetic: Sparkles, coordination: Plane };

const Services = () => {
  const { t, isRtl } = useLanguage();

  return (
    <section id="services" data-testid="services-section" className="py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <SectionHeader
          eyebrow={t.services.eyebrow}
          heading={t.services.heading}
          sub={t.services.sub}
        />

        <div className="mt-16 grid gap-8 md:grid-cols-3">
          {t.services.items.map((item, i) => {
            const Icon = ICONS[item.key];
            const img = BUSINESS.images[item.key];
            return (
              <Reveal key={item.key} delay={i * 0.12}>
                <article
                  data-testid={`service-card-${item.key}`}
                  className="group h-full overflow-hidden rounded-2xl border border-line bg-white shadow-[0_8px_30px_rgba(28,27,26,0.04)] transition-[box-shadow,transform] duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_50px_rgba(28,27,26,0.09)]"
                >
                  <div className="relative h-56 overflow-hidden">
                    <img
                      src={img.src}
                      alt={isRtl ? img.altAr : img.altEn}
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                    <span className="absolute start-5 top-5 rounded-full bg-white/85 px-3 py-1 font-head text-sm text-bronze-dark backdrop-blur-sm">
                      {item.number}
                    </span>
                  </div>
                  <div className="flex flex-col gap-4 p-8">
                    <span className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-sand text-bronze-dark">
                      <Icon className="h-5 w-5" />
                    </span>
                    <h3 className="font-head text-2xl text-ink">{item.title}</h3>
                    <p className="text-sm md:text-base leading-relaxed text-taupe">{item.text}</p>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
